

import { api } from '@/services/api';
import { store } from '@/store';
import Vue from 'vue'
export default Vue.extend({
    data() {
        return {
            user: "",
            password: ""
        };
    },
    mounted() {
        if (this.isLoggedIn) {
            this.$router.push("/");
        }
    },
    methods: {
        async login() {
            const check = (e: string | undefined) => e && e.length > 0;
            if (check(this.user) && check(this.password)) {
                const result = await api.login(this.user, this.password);
                if (result) {
                    store.user = result;
                }
            }
            return false;
        },
    },
    computed: {
        isLoggedIn() {
            return store.user !== undefined;
        }
    },
    watch: {
        isLoggedIn($new, old) {
            if ($new && !old) {
                this.$router.push("/");
            }
        }
    }
})
